<template>
    <div class="w-80 mx-auto">
        <div class="section-heading">
            <h3 class="orange-color">
                About US
                <span class="section-title-divider">
            <img src="/img/icons/divider.png" alt="divider" class="img-fluid"/>
          </span>
            </h3>
        </div>
        <section class="content">
            <p><strong>NUTRON</strong> is 100 percent New Zealand owned, located in the heart of Chiristchurch CBD. We
                previously operated under
                ‘OOBE Christchurch’ with branches located in Westfield Riccarton and Blenheim Road for a number of
                years. We
                have recently re-branded to <strong>NUTRON</strong> to deliver a brand new customer centric technology
                experience. We are a
                premium technology destination and pride ourselves in delivering great service & excellent customer
                outcomes. We
                are a team of highly skilled and knowledgeable staff who take the time to understand your needs and
                provide a
                suitable technology solution. Whether you are home user, a professional, a small business or a large
                corporate
                we always put our customer’s needs first and strive to achieve the best outcome.</p>

            <p>We are your local destination for all things <strong>APPLE</strong>. We are an <strong>APPLE</strong>
                Authorised Service Provider and Authorised
                Reseller. We aim to provide a complete solution from sales to service. We look after Warranty & Out of
                Warranty
                Repairs for Apple Computers and iOS Devices. Our services include hardware & software troubleshooting
                and
                repairs being fully compliant with Apple requirements. All our technicians are certified technicians and
                have a
                lot of experience in dealing with all hardware & software issues. Our on-site service centre uses Apple
                provided
                diagnostic tools and procedures to ensure that your Apple products remain compliant with Apple
                requirements.</p>

            <p>We are easily accessible with plenty of off-street parking on nearby streets and also have abundant
                parking
                options within The Crossing car park and City Council car parking. Located at <strong>678 Colombo
                    Street, Christchurch
                    CBD.</strong></p>

            <p>We have recently moved to Colombo Street and have a brand new exciting technology store different from
                large
                scale retailers.</p>

            <p>We also offer a lot of other brands like Beats Audio, E-Scooters, branded accessories, home automation
                and other
                popular brands like HP computers.</p>

            <p>Come and visit our new store and one of our friendly staff will be happy to show you around and provide
                technology solutions suitable to your needs.</p>
        </section>
    </div>
</template>

<script>
    import LayoutDefault from "@/layouts/LayoutDefault";

    export default {
        created() {
            this.$emit('update:layout', LayoutDefault);
            this.$root.$emit('closenav', false);
        }
    };
</script>
<style lang="scss" scoped>
    .content {
        margin-bottom: 30px;

        p {
            line-height: 34px;
        }
    }
</style>